import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const toolsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "tools",
  path: "/tools",
  heading: { text: "Tool View", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "deny",
    "coach": "deny",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/tools.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default toolsScreenModule;
